import React from 'react'
import { observer } from 'mobx-react'
import useCollection from './hooks/use-collection'
import useModelKeyName from '../hooks/use-model-key-name'
import IndexContext from '../contexts/IndexContext'
import shortid from 'shortid'

function ForEach (props) {
  const collection = useCollection()
  const modelKeyName = useModelKeyName()

  return collection.map((entry, index) => {
    let entryKey = null

    if (typeof entry.__unique_key !== 'undefined') {
      entryKey = entry.__unique_key
    } else {
      if (modelKeyName) {
        if (typeof entry.get === 'function') {
          entryKey = entry.get(modelKeyName)
        } else if (typeof entry[modelKeyName] !== 'undefined') {
          entryKey = entry[modelKeyName]
        }
      }
    }

    if (!entryKey) {
      entryKey = shortid()
    }

    if (typeof entry === 'object' && entry !== null) {
      entry.__unique_key = entryKey
    }

    return (
      <IndexContext.Provider value={index} key={entryKey}>
        {props.children}
      </IndexContext.Provider>
    )
  })
}

export default observer(ForEach)
